const menus = [

    {
        id: 2,
        name: 'Nosotros',
        links: '/nosotros'
    },
    {
        id: 3,
        name: 'Habitaciones',
        links: '/habitaciones',
        namesub: [
            {
                id: 1,
                sub: 'Sami',
                links: '/sami'
            },
            {
                id: 2,
                sub: 'Killa',
                links: '/killa'
            },
            {
                id: 3,
                sub: 'Aliwen',
                links: '/aliwen'
            },
            {
                id: 4,
                sub: 'Amaru',
                links: '/amaru'
            },
            {
                id: 5,
                sub: 'Chaski',
                links: '/chaski'
            },
            {
                id: 6,
                sub: 'Inti',
                links: '/inti'
            },
            {
                id: 7,
                sub: 'Nina',
                links: '/nina'
            },
            {
                id: 8,
                sub: 'Pacha',
                links: '/pacha'
            },
            {
                id: 9,
                sub: 'Shangu',
                links: '/shangu'
            },
            {
                id: 10,
                sub: 'Wayiki',
                links: '/wayiki'
            },
            {
                id: 11,
                sub: 'Wayta',
                links: '/wayta'
            },

        ],
    },
    {
        id: 4,
        name: 'Servicios',
        links: '/servicios-rodex'
    },
    {
        id: 5,
        name: 'Contacto',
        links: '/contact'
    },
    {
        id: 6,
        name: 'Tucuman',
        links: '/que-hacer'
    },


]

export default menus;